import React, { useEffect, useState } from "react"
import { withRouter, Link } from "react-router-dom"

import MetaTags from "react-meta-tags"

import { Container } from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import { getData } from "./data"
import { Filters } from "./Filters"
import Table from "./Table"
import axios from "axios"
import {API_URL, sitename} from "constants/constants"
import moment from "moment";
const ShopReport = props => {
  const [item, setItem] = useState("All")
  const [shopReportsData, setShopReportsData] = useState([])
  const [toDate, setToDate] = useState(moment().format("YYYY-MM-DD"))
  const [fromDate, setFromDate] = useState(moment().format("YYYY-MM-DD"))

  useEffect(() => {
    call()
  }, [])

  const call = () => {
    axios({
      method: "get",
      url: `${API_URL}/admin/reports/shop-reports?to=${toDate}&from=${fromDate}`,
    })
        .then(function (response) {
          setShopReportsData(response?.data?.data)
        })
        .catch(function (response) {
        })
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{sitename}</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title="Admin" breadcrumbItem="Shop Report" />
        </Container>
        <Filters item={item}
                 setItem={setItem}
                 toDate={toDate}
                 fromDate={fromDate}
                 setToDate={d => setToDate(d)}
                 setFromDate={d => setFromDate(d)}
                 call={() => {
                   call()
                 }}
        />
        <Table data={shopReportsData} />
      </div>
    </React.Fragment>
  )
}
export default withRouter(ShopReport)
